import { BirthdayGreetingsService, QueryHandlingService } from '@akebono/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { isRussianUser } from 'src/app/const';
import {
  Alert,
  AlertTargetEnum,
  UserCountryIsoGQL,
} from 'src/app/modules/graphql/service/graphql-auto-main-service';
import { AlertService } from 'src/app/modules/shared-components/alerts-list/alert.service';
import { ConnectTelegramService } from 'src/app/modules/shared-components/connect-telegram/connect-telegram.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  alerts$: Observable<Alert[]>;
  isRussianUser$: Observable<boolean>;
  readonly mirrorSiteUrl =
    !environment.production || environment.staging
      ? `https://${environment.domain}/`
      : 'https://by.ecarjp.com/';

  private destroy$ = new Subject<void>();

  constructor(
    title: Title,
    private alertService: AlertService,
    private connectTelegramService: ConnectTelegramService,
    private birthdayGreetingsService: BirthdayGreetingsService,
    private qhs: QueryHandlingService,
    private userCountryIsoGQL: UserCountryIsoGQL,
  ) {
    title.setTitle('ECar JP');
  }

  ngOnInit(): void {
    this.isRussianUser();
    this.alerts$ = this.alertService.getAlerts(null, AlertTargetEnum.MainPage);
    this.birthdayGreetingsService.checkBirthday();
    this.connectTelegramService
      .watch('settings', 'telegram')
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  private isRussianUser(): void {
    this.isRussianUser$ = this.qhs
      .fetch(this.userCountryIsoGQL)
      .data.pipe(map((data) => !!data?.currentUser && isRussianUser(data.currentUser)));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
